"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ModalUtil = /** @class */ (function () {
    function ModalUtil() {
    }
    // Fix z-index issue with ams.css
    ModalUtil.displayModal = function () {
        ModalUtil.getAmsHeader().style.zIndex = '100';
        ModalUtil.getAmsNav().style.zIndex = '99';
        ModalUtil.getAmsContent().style.zIndex = '99';
    };
    ModalUtil.hideModal = function () {
        ModalUtil.getAmsHeader().removeAttribute('style');
        ModalUtil.getAmsNav().removeAttribute('style');
        ModalUtil.getAmsContent().removeAttribute('style');
    };
    ModalUtil.getAmsHeader = function () {
        return document.getElementsByClassName('ams-header')[0];
    };
    ModalUtil.getAmsNav = function () {
        return document.getElementsByClassName('ams-leftnav')[0];
    };
    ModalUtil.getAmsContent = function () {
        return document.getElementsByClassName('ams-contentWrapper')[0];
    };
    return ModalUtil;
}());
exports.default = ModalUtil;
//# sourceMappingURL=ModalUtil.js.map